import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';
import { CommonWrapper, SectionTitle } from 'screens/AgentOfficePages/styled';
import { typographyFontSizeCfg } from 'ds/components/typography/types';
import { Link } from 'components/link';
import { AwardsMode } from 'screens/AgentOfficePages/common/sections/awards/Awards';

export const Wrapper = styled(CommonWrapper)<{ carouselMode: AwardsMode }>`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(5)};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
      flex-direction: column;
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 })`
      gap: ${theme.spacing(4)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
      gap: ${theme.spacing(3)};
  `}
  ${({ theme, carouselMode }) => carouselMode === AwardsMode.Carousel ? theme.media.showAt({ from: 3 })`
    flex-direction: column;
  ` : ''} `;


export const AboutSectionWrapper = styled.div<{ noShrink?: boolean }>`
  flex-shrink: ${({ noShrink }) => noShrink ? 0 : 1};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    overflow: hidden;
    border: 1px solid ${theme.colors.neutrals.grey8};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing(2)};
  `}
`;

export const DescriptionTitle = styled(SectionTitle)(({ theme }) => `
  max-width: calc(100% - 212px);
  display: flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
`);

export const Subtitle = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
  margin: ${({ theme }) => `${theme.spacing(1)} 0`};
`;

export const DescriptionText = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-top: ${({ theme }) => theme.spacing(3)};
  .description-read-more {
    padding-bottom: 0;
    div {
      padding-bottom: 0;
    }
  }
`;

export const ShowMoreWrapper = styled.div<{ isOpen?: boolean; isDesktop?: boolean }>`
  padding: ${({ theme }) => theme.spacing(1)} 0;
  background: ${({ theme, isDesktop }) => isDesktop ? 'none' : `linear-gradient(0deg, ${theme.colors.neutrals.white} 81.76%, ${colorToAlpha(theme.colors.neutrals.white, 0)} 253.19%)`};
  margin-top: ${({ theme, isOpen, isDesktop }) => !isOpen && !isDesktop ? `-${theme.spacing(2)}` : 0};
  margin-bottom: -${({ theme }) => theme.spacing(2)};
  z-index: 1;
  position: relative;
  && > * {
    font-size: ${typographyFontSizeCfg.text}px;
  }
  && svg {
    ${({ isOpen }) => isOpen ? '' : `
      transform: rotate(180deg);
    `}
  }
`;

export const AwardsWrapper = styled.div<{ carouselMode?: AwardsMode }>`
  ${({ theme, carouselMode }) => theme.media.showAt({ from: 3 })`
    ${carouselMode === AwardsMode.Carousel ? `
    .view-pager-rail > .view-pager-bow {
      gap: ${theme.spacing(1)};
    }
  ` : `
    width: 458px;
    flex-shrink: 0;
  `}
`}`;

export const OfficeWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
}));

export const OfficeName = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const OfficeLogoBox = styled(Link)(({ theme }) => ({
  display: 'block',
  overflow: 'hidden',
  borderRadius: theme.borderRadius.tiny,
  textDecoration: 'none',
  zIndex: 1,
  width: '40px',
  height: '40px',
  padding: theme.spacing(0.25),
  boxShadow: theme.shadow.level2,
  background: theme.colors.neutrals.white,
  'img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    transition: 'transform 0.1s ease-out, box-shadow 0.1s ease-out',
  },
}));
